<template>
  <div>
    <h3
      class="ts-text-xs ts-uppercase ts-text-blue-700"
    >{{ $t('employeeProfile.socailSecurityNumber') }}</h3>
    <form class="form-horizontal">
      <div class="row">
        <div class="col-md-6 ts-space-y-4">
          <div class="row">
            <label
              class="col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.ssnNo') }}</label>
            <div class="col-md-7">
              <input v-model="model.ssn_no" type="text" class="form-control" />
              <div class="validate" v-if="errors.has('ssn_no')">{{ errors.first('ssn_no') }}</div>
            </div>
          </div>
          <div class="row">
            <label
              class="col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.ssnIssueAt') }}</label>
            <div class="col-md-7">
              <input v-model="model.ssn_issued_at" type="text" class="form-control" />
              <div
                class="validate"
                v-if="errors.has('ssn_issued_at')"
              >{{ errors.first('ssn_issued_at') }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 ts-space-y-4">
          <div class="row">
            <label
              class="col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.issueDate') }}</label>
            <div class="col-md-7">
              <a-date-picker
                v-model="model.ssn_issued_date"
								format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                class="ts-w-full"
              ></a-date-picker>
              <div
                class="validate"
                v-if="errors.has('ssn_issued_date')"
              >{{ errors.first('ssn_issued_date') }}</div>
            </div>
          </div>
          <div class="row">
            <label
              class="col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.expireDate') }}</label>
            <div class="col-md-7">
              <a-date-picker
                v-model="model.ssn_expiry_date"
								format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                class="ts-w-full"
              ></a-date-picker>
              <div
                class="validate"
                v-if="errors.has('ssn_expiry_date')"
              >{{ errors.first('ssn_expiry_date') }}</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'socialSecurityNumber',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>